<script>
  // import Progress from './progress.svelte';
  import { onMount } from 'svelte';
  import ContainerProgress from '../../components/layout/containerprogress.svelte';
  export let content;
  export let idUnico;

  let comandoBegin;
  let comandoEnd;
  let comandoFrase;

  comandoBegin = content.search('<comando>');
  if (comandoBegin != -1) {
    comandoEnd = content.search('</comando>');
    if (comandoEnd != -1) {
      comandoFrase = content.substring(comandoBegin + 9, comandoEnd);
      content = content.substring(comandoEnd + 10, content.length);
    }
  }

  content = content.split(';;');

  let root;

  function refresh_bar(text_items, bar, current, quantum, i) {
    let bar_val;
    j$(text_items[current]).addClass('not-active');
    current = current + i;

    j$(text_items[current]).removeClass('not-active');
    bar_val = current == text_items.length - 1 ? 100 : Math.round(quantum + quantum * current);

    bar.attr('aria-valuenow', bar_val);
    bar.css('width', bar_val + '%');

    return current;
  }

  onMount(() => {
    let current = 0;
    let next_bt = j$(`#${idUnico}`).find('.progress-next');
    let prev_bt = j$(`#${idUnico}`).find('.progress-prev');
    let bar = j$(`#${idUnico}`).find('.progress-bar');
    let text_box = j$(`#${idUnico}`).find('.text-area');
    let text_items = j$(`#${idUnico}`).find('.text-item');
    let max_len = text_items.length;
    let quantum = 100 / text_items.length;
    // let height = set_same_height_collection(text_items);
    // text_items.css('height', `${height + 35}px`);

    setTimeout(function () {
      let text_items = j$(`#${idUnico} .text-item`);
      text_items.each((element, object) => {});
      let height = set_same_height_collection(text_items);
      text_items.css('height', `${height + 16}px`);
    }, 500);

    refresh_bar(text_items, bar, current, quantum, 0);
    prev_bt.addClass('inactive');

    next_bt.on('click', function () {
      prev_bt.removeClass('inactive');
      if (current < max_len - 1) {
        current = refresh_bar(text_items, bar, current, quantum, 1);
        if (current === max_len - 1) {
          next_bt.addClass('inactive');
        }
      }
    });

    prev_bt.on('click', function () {
      if (current > 0) {
        current = refresh_bar(text_items, bar, current, quantum, -1);
        next_bt.removeClass('inactive');
        if (current === 0) {
          prev_bt.addClass('inactive');
        }
      }
    });
  });
</script>

<div class="container" id={idUnico} bind:this={root}>
  <!-- <p class="comando">
    {@html comandoFrase}
  </p> -->
  <div class="row">
    <div class="col-md-10 mx-auto">
      <div class="progress-bar-container">
        <div class="progress">
          <div
            class="progress-bar"
            role="progressbar"
            style="width: 0%;"
            aria-valuenow="0"
            aria-valuemin="0"
            aria-valuemax="100"
          />
        </div>

        <div class="text-area row col-md-9 mx-auto">
          {#each content as c, index}
            <ContainerProgress>
              <span class={index == 0 ? 'comando-progress' : ''}>
                {@html c}
              </span>
            </ContainerProgress>
          {/each}
        </div>

        <div class="button-panel">
          <div class="progress-bar-button-wrapper">
            <button
              class="radial-bt progress-prev pointer"
              data-ripplet="appendTo: parent; color: var(--COR_3);"
            />
            <button
              class="radial-bt progress-next pointer"
              data-ripplet="appendTo: parent; color: var(--COR_3);"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  @media screen and (prefers-reduced-motion: reduce) {
    .progress-bar {
      transition: none;
    }
  }

  .container {
    /* margin-top: calc(3rem + 0.4rem); */
    margin-bottom: calc(2.5rem + 0.5rem);
  }

  .progress-bar-container {
    padding: 35px 20px 25px 20px;
    border: 2px solid var(--MARROM);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
    margin-bottom: 15px;
    border-radius: 15px;
  }

  .button-panel {
    width: 100%;
    margin-bottom: 0px;
  }

  .progress-bar-button-wrapper {
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
  }

  .radial-bt {
    position: relative;
    all: unset;
    cursor: pointer;
    height: 50px;
    width: 50px;
    background: var(--COR_BRANCO);
    /* filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.2)); */
  }

  .progress-next {
    margin-left: 20px;
  }

  .progress {
    position: absolute;
    top: -1rem;
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    background-color: var(--BRANCO);
    border: 2px solid var(--MARROM);
    padding: 1px;
    box-sizing: border-box;
    border-radius: 14px;
    height: 2rem !important;
  }

  .progress-bar {
    background: linear-gradient(
      to right,
      var(--VERDE_CLARO) 0%,
      var(--VERDE_CLARO) 90%,
      var(--VERDE_CLARO) 100%
    );
    border-radius: 12px;
  }

  .progress-next {
    background-image: url(../assets/images/icons/seta-next.svg);
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
    border: 2px solid var(--MARROM);
  }

  .progress-prev {
    background-image: url(../assets/images/icons/seta-next.svg);
    background-repeat: no-repeat;
    background-position: center;
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
    -moz-transform: scaleX(-1); /* Gecko */
    -o-transform: scaleX(-1); /* Opera */
    -webkit-transform: scaleX(-1); /* Webkit */
    transform: scaleX(-1); /* Standard */
    border-radius: 50%;
    border: 2px solid var(--MARROM);
  }

  .progress-bar-container :global(.text-item.not-active) {
    display: none;
  }

  :global(.radial-bt.inactive) {
    filter: grayscale(1);
    user-select: none;
    cursor: unset;
  }

  :global(.text-item p) {
    font-weight: 600;
    color: var(--COR_FONT);
  }

  :global(.text-item) {
    width: 100%;
  }

  :global(.text-item:nth-child(1)) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  :global(.text-item:nth-child(1)) {
    text-align: center;
  }

  .col-md-9 {
    max-width: 95%;
    padding: 0;
  }

  :global(.comando-progress) {
    font-family: var(--FONT_INTER);
    font-size: 18px;
    text-align: center;
    font-weight: 400;
  }

  @media (max-width: 767px) {
    .col-md-9 {
      max-width: 95%;
      padding: 0;
    }
  }
</style>
